import * as React from "react";
import { useAuth } from "../services/authentication";
import { RouteProps, Route } from "react-router-dom";
import LoginPage from "../pages/LoginPage";

const ProtectedRoute: React.FC<RouteProps> = props => {
    const { authState } = useAuth();

    if (authState.loggedIn) {
        return <Route {...props} />;
    }

    return <LoginPage />;
};

export default ProtectedRoute;
